import { Component, OnInit } from '@angular/core';
import { ICustomerWallet } from '../../interfaces/customer-wallet.interface';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { CustomerWalletAction } from '@hub-workspace/apps/logged-home/src/app/state-management/customer-wallet/customer-wallet.action';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import {
  ModalAccessFullWalletComponent
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/components/modal-full-wallet/modal-access-full-wallet.component';
import {
  WALLET_FULL_ACCESS_ALERT_LINK_LABEL,
  WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT,
  WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER,
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/components/wallet-full-access-alert/wallet-full-access-alert.constants';
import { OneViewExperienceVariant } from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.util';
import { OneViewExperienceVariantService } from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/services/oneview-experience-variant/oneview-experience-variant.service';

@Component({
    selector: 'tr-customer-wallet-panel',
    templateUrl: './wallet-panel.component.html',
    styleUrls: ['./wallet-panel.component.scss'],
})
export class CustomerWalletPanelComponent implements OnInit {

    public wallet: ICustomerWallet = null;

    public oneViewExperienceVariant$: Observable<OneViewExperienceVariant>;
    private oneViewExperienceVariant: OneViewExperienceVariant | null = null;

    constructor(
        private store: Store<ILoggedHomeAppState>,
        private router: Router,
        private dialogsService: DialogsService,
        private oneViewExperienceVariantService: OneViewExperienceVariantService,
    ) { }

    public ngOnInit() {
        this.store
            .select((state) => state.customerWallet)
            .pipe(
                tap(({ wallet, pending, isLoaded }) => {
                    if (!wallet && !pending && !isLoaded) {
                        this.store.dispatch({
                            type: CustomerWalletAction.getCustomerWallet
                        })
                    }
                }),
                filter(({ isLoaded, wallet }) => isLoaded && !!wallet),
            )
            .subscribe(({ wallet }) => this.wallet = wallet);

        this.oneViewExperienceVariant$ = this.oneViewExperienceVariantService.variant$.pipe(
            take(1),
            tap((variant) => this.oneViewExperienceVariant = variant),
        );
    }

    public openModalAccessFullWallet() {
      this.dialogsService.showComponnent(ModalAccessFullWalletComponent);

      const isNewExperience = this.oneViewExperienceVariant === 'new';
      const alertText = isNewExperience
        ? WALLET_FULL_ACCESS_ALERT_TEXT_SANTANDER
        : WALLET_FULL_ACCESS_ALERT_TEXT_DEFAULT;

      this.sendTracking("Element Clicked", {
        'Product Area Origin': 'Home',
        'Time Responsável': "Mezzo",
        'Element': 'Link Saiba mais',
        'Group': 'Alert Carteira',
        'Step': 'Não se aplica',
        'Scenario': 'Exclusivo',
        'Text': `${alertText} ${WALLET_FULL_ACCESS_ALERT_LINK_LABEL}`
      });
    }

    public categoryElementClicked(slug: string, name: string) {
        this.router.navigate(['/minha-carteira/alocacao'], { queryParams: { category: slug } });

        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Home',
            'Time Responsável': "Mezzo",
            'Element': name,
            'Group': 'Alocação da carteira',
        });
    }

    public walletElementClicked() {
        this.router.navigate(['/minha-carteira/alocacao']);

        this.sendTracking("Element Clicked", {
            'Product Area Origin': 'Home',
            'Time Responsável': "Mezzo",
            'Element': 'CustomerWalletGraph',
            'Group': 'Alocação da carteira',
        });
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}
